import { z } from 'zod';
import { globalSearchSchema } from 'src/modules/shared/schemas/search.schema';

const searchSchema = z.object({
  phoneVersion: globalSearchSchema.shape.phoneVersion.transform(() => 'v1'),
});

/**
 * Schema for validating search parameters in the user view.
 * Extends the global search schema.
 */
export const userSearchSchema = globalSearchSchema.merge(searchSchema);

/**
 * Type definition for the user search parameters.
 */
export type UserSearch = z.infer<typeof userSearchSchema>;
